import { createSlice } from "@reduxjs/toolkit";

const initialAssignTraineeState = {
  sourceList: [], //Left
  checked: [], //Checked
  //   sourceChecked : [], //LeftChecked
  rosterList: [], //List of rosterData
  classRequestId: 0,
  traineesData: [],
  requisitionID: "",
  totalTraineeCount: 0,
  IDMRosters: [],
  rosterConfigDetails: [],
  allClassRequestIds: [],
  searchedRoster: 0,
  searchedClassReqId: 0,
  initialRosterList: [],
  modifiedRosters: [],
  unAssignedTraineesList: [],
};

const handleSourceList = (currentState, actionPayload) => {
  const oracleIds = actionPayload.map((item) => item.split("-").shift());
  const distinct = [...new Set(oracleIds)];
  const returnValue = distinct.map(
    (item) => `${item}-${currentState.requisitionID}`
  );
  return returnValue;
};

const handleAddOrRemove = (currentState, value) => {
  const source = currentState;
  if (!source.includes(value)) {
    source.push(value);
  } else {
    source.splice(source.indexOf(value), 1);
  }
  return source;
};

const addIfNotExists = (currentState, value) => {
  const source = currentState;
  if (!source.includes(value)) {
    source.push(value);
  }
  return source;
};

const removeIfExists = (currentState, value) => {
  const source = currentState;
  if (source.includes(value)) {
    source.splice(source.indexOf(value), 1);
  }
  return source;
};

const handleRosterList = (rosterList, actionPayload) => {
  const rosterExists = rosterList.filter(
    (value) => value.rosterId === actionPayload?.rosterId
  );
  let distinctIds = [...new Set(actionPayload.Ids)];
  let newPayload = [];
  if (rosterExists.length > 0) {
    newPayload = rosterList.map((value) => {
      if (value?.rosterId === actionPayload?.rosterId) {
        return {
          rosterId: value.rosterId,
          Ids: distinctIds,
          isEmptyRoster: value.isEmptyRoster,
        };
      } else {
        return value;
      }
    });
    return newPayload;
  } else {
    rosterList.push(actionPayload);
    return rosterList;
  }
};

const assignTrainee = createSlice({
  name: "Assign trainees",
  initialState: initialAssignTraineeState,
  reducers: {
    setClassRequestId(state, action) {
      state.classRequestId = action.payload;
    },
    setTraineesData(state, action) {
      state.traineesData = [...state.traineesData, ...action.payload];
    },
    setRequestionId(state, action) {
      state.requisitionID = action.payload;
    },
    setSourceList(state, action) {
      state.sourceList = action.payload
        ? handleSourceList(state, action.payload)
        : [];
    },
    setChecked(state, action) {
      state.checked = action.payload ? action.payload : [];
    },
    setRosterList(state, action) {
      state.rosterList = handleRosterList(state.rosterList, action.payload);
    },
    AddExistingRosters(state, action) {
      state.rosterList = action.payload ? action.payload : [];
    },
    setTotalTraineeCount(state, action) {
      state.totalTraineeCount = action.payload ? action.payload : 0;
    },
    setIncludeInIDM(state, action) {
      //state.IDMRosters = handleAddOrRemove(state.IDMRosters, action.payload); // Commented as per ASTT-5564, might Re-visit.
      state.IDMRosters = [action.payload];
    },
    setAllClassRequestIds(state, action) {
      state.allClassRequestIds = action.payload ? action.payload : [];
    },
    setSearchedRoster(state, action) {
      state.searchedRoster = action.payload;
    },
    setSearchedClassReqId(state, action) {
      state.searchedClassReqId = action.payload;
    },
    setInitialRosterList(state, action) {
      state.initialRosterList = action.payload ? action.payload : [];
    },
    addModifiedRosters(state, action) {
      state.addedTrainees = addIfNotExists(
        state.modifiedRosters,
        action.payload
      );
    },
    removeModifiedRoster(state, action) {
      state.addedTrainees = removeIfExists(
        state.modifiedRosters,
        action.payload
      );
    },
    setUnAssignedTraineesList(state, action) {
      state.unAssignedTraineesList = action.payload ? action.payload : [];
    },
    setRosterConfigDetails(state, action) {
      state.rosterConfigDetails = action.payload;
    },
    resetAssignTrainee: (state, action) => ({
      ...initialAssignTraineeState,
      traineesData: state.traineesData,
      allClassRequestIds: state.allClassRequestIds,
      searchedRoster: state.searchedRoster,
      searchedClassReqId: state.searchedClassReqId,
      rosterList: state.initialRosterList,
      initialRosterList: state.initialRosterList,
      classRequestId: state.classRequestId,
    }), //Not Resetting global used values in Reset --ASTT-2204
  },
});

export const assignTraineeActions = assignTrainee.actions;
export default assignTrainee.reducer;
